import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DTOAccessory } from '../../../../../@core/models/DTOAccessory';
import { DTOCashOnDelivery } from '../../../../../@core/models/DTOCashOnDelivery';
import { DTOShipment } from '../../../../../@core/models/DTOShipment';
import { ShipmentService } from '../../../../../@core/services/shipment.service';

interface Option {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'crm-update-shipment-dialog',
  templateUrl: './crm-update-shipment-dialog.component.html',
  styleUrls: ['./crm-update-shipment-dialog.component.scss']
})
export class CrmUpdateShipmentDialogComponent implements OnInit {
  shipment: DTOShipment;
  @ViewChild('shipmentForm', null) shipmentForm: NgForm;

  userId: string;
  lang: string;
  key: string;
  searchButton;
  error: string;
  submitted: boolean = false;

  expeditionDate: string;
  customerId: number;
  shipmentType: string;
  totalParcels: number;
  totalWeight: number;
  referenceNumber: string;
  billingAccount: number;

  /**
   * Accessory
   */
  accInsuranceAmount?: number;
  accFrozenProtection?: boolean;
  accDangerousGoods?: boolean;
  accBefore10h30am?: boolean;
  accSNR: boolean;

  /**
   * CashOnDelivery
   */
  codType: string;
  codAmount: number;

  codOptions: Option[] = [];

  constructor(
    public dialogRef: MatDialogRef<CrmUpdateShipmentDialogComponent>,
    public toastservice: ToastrService,
    private _shipmentService: ShipmentService,
    public _translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.shipment = this.data.shipment;
    this.userId = this.data.userId;
    this.key = this.data.key;
    this.expeditionDate = this.datePipe.transform(
      this.shipment.ExpeditionDate,
      'yyyy-MM-dd'
    );
    this.codType = this.shipment.Accessory.COD.CODType;
    this.codAmount = this.shipment.Accessory.COD.CODAmount;

    this.accInsuranceAmount = this.shipment.Accessory.InsuranceAmount;
    this.accFrozenProtection = this.shipment.Accessory.FrozenProtection;
    this.accDangerousGoods = this.shipment.Accessory.FrozenProtection;
    this.accBefore10h30am = this.shipment.Accessory.Before10h30am;
    this.accSNR = this.shipment.Accessory.SNR;
    this.billingAccount = Number(this.shipment.Sender.AccountNumber);

    this.shipmentType = this.shipment.ShipmentType;
    this.totalParcels = this.shipment.TotalParcels;
    this.totalWeight = this.shipment.TotalWeight;
    this.referenceNumber = this.shipment.ReferenceNumber;
    this.customerId = this.shipment.CustomerId;
  }

  async ngAfterViewInit(): Promise<void> {
    await this._translateService.get('dummyTranslation').toPromise().then();
    let none = this._translateService.instant('crm.lbl-none');
    this.codOptions = [
      {
        value: 'NoCOD',
        viewValue: none
      },
      {
        value: 'Check',
        viewValue: this._translateService.instant('crm.lbl-cash-or-check')
      },
      {
        value: 'Cash',
        viewValue: this._translateService.instant('crm.lbl-cash-only')
      },
      {
        value: 'PostDatedCheck',
        viewValue: this._translateService.instant('crm.lbl-postdated-check')
      },
      {
        value: 'CertifiedCheck',
        viewValue: this._translateService.instant('crm.lbl-certified-check')
      }
    ];
  }

  ngOnInit() {}

  public close(): void {
    this.dialogRef.close(false);
  }

  onSubmit() {
    this.submitted = true;
    let cashOnDelivery: DTOCashOnDelivery = {
      CODType: this.codType,
      CODAmount: this.codAmount
    };

    let accessory: DTOAccessory = {
      InsuranceAmount: this.accInsuranceAmount,
      FrozenProtection: this.accFrozenProtection,
      DangerousGoods: this.accDangerousGoods,
      Before10h30am: this.accBefore10h30am,
      SNR: this.accSNR,
      COD: cashOnDelivery
    };

    this.shipment.CustomerId = this.customerId;
    this.shipment.ExpeditionDate = this.expeditionDate;
    this.shipment.ShipmentType = this.shipmentType;
    this.shipment.TotalParcels = this.totalParcels;
    this.shipment.TotalWeight = this.totalWeight;
    this.shipment.ReferenceNumber = this.referenceNumber;
    this.shipment.BillingAccount = this.billingAccount;
    this.shipment.Accessory = accessory;
    this.shipment.Sender.AccountNumber = this.billingAccount.toString();
    this._shipmentService
      .UpdateShipment(this.shipment, this.userId, this.key, false)
      .subscribe((res) => {
        this.toastrService.success(
          this._translateService.instant('Status'),
          this._translateService.instant('crm.lbl-shipment-updated'),
          {
            positionClass: 'toast-top-center',
            disableTimeOut: false,
            enableHtml: true
          }
        );

        this.close();
      });
  }
}
